function BaseDB(name, options) {
  const self = this

  self.dbName = name
  self.isActive = false
  self.db = null
  self.loaded = false

  self.autoInit = options.autoInit || true

  self.key = options.key || 'key'
  self.dataKey = options.dataKey || 'data'
  self.indexedDataKey = options.dataKey || false
  self.version = options.version || 1
  self.indexList = options.indexList || []

  self.expireDuration = 30 * 24 * 60 * 60 * 1000 // default. 30일 후 만료.
  if (options.expireDuration != null) {
    self.expireDuration = options.expireDuration
  } else if (options.expireDuration === null) {
    self.expireDuration = null
  }

  // 내부에 메일 배열을 가지고 있도록 하여, 없는 것만 새로 DB에 추가하도록 처리(배열에도 함께 추가.).
  // 데이터를 가져가는 것은 배열에서 가져가도록 할 것.
  // 표시되는 메세지의 날짜에 맞춰서 적당히 가져가도록~!!
  self.dataMap = {}

  self.isInitialing = false
  self.initWaitingReq = []

  const init = () => {
    return new Promise((resolve, reject) => {
      if (self.isInitialing !== true) {
        self.isInitialing = true

        const DBOpenRequest = window.indexedDB.open(self.dbName, self.version)

        DBOpenRequest.onerror = (error) => {
          console.log('error - db open failed', error)
          self.isActive = false
        }

        DBOpenRequest.onsuccess = (event) => {
          self.db = event.target.result

          self
            .load()
            .then((ret) => {
              self.isActive = true

              self.initWaitingReq.forEach((promise) => {
                promise.resolve(ret)
              })
              self.initWaitingReq = []

              self.isInitialing = false
              resolve(ret)
            })
            .catch((err) => {
              self.initWaitingReq.forEach((promise) => {
                promise.reject(err)
              })
              self.initWaitingReq = []

              self.isInitialing = false
              reject(err)
            })
        }

        DBOpenRequest.onupgradeneeded = (event) => {
          const db = event.target.result

          db.onerror = (error) => {
            console.log('error - db upgrade.', error)
            self.isActive = false

            self.initWaitingReq.forEach((promise) => {
              promise.reject(error)
            })
            self.initWaitingReq = []

            self.isInitialing = false
            reject(error)
          }

          if (event.oldVersion === 1) {
            db.deleteObjectStore(self.dbName)
          }

          const objectStore = db.createObjectStore(self.dbName, { keyPath: self.key })
          // const objectStore = db.createObjectStore(self.dbName, { keyPath: 'url' })

          // objectStore.createIndex('conversationId', 'conversationId', { unique: true })
          if (self.expireDuration != null) {
            objectStore.createIndex('expireTime', 'expireTime', { unique: false })
          }
          // objectStore.createIndex('id', 'id', { unique: true })

          if (this.indexedDataKey === true) {
            objectStore.createIndex(self.dataKey, self.dataKey, { unique: false })
          }

          self.indexList.forEach((item) => {
            objectStore.createIndex(item, item, { unique: false })
          })
        }
      } else {
        self.initWaitingReq.push({
          resolve,
          reject,
        })
      }
    })
  }

  self.close = () => {
    if (self.isActive === true) {
      self.db.close()
    }
    self.isActive = false
  }

  self.isloading = false
  self.loadWaitingReq = []

  self.load = () => {
    return new Promise((resolve, reject) => {
      if (self.isloading !== true) {
        self.dataMap = {}
        self.isloading = true
        if (self.expireDuration != null) {
          const transaction = self.db.transaction([self.dbName], 'readwrite')

          transaction.onerror = (tEvent) => {
            console.log('Transaction not opened due to error.', tEvent)
            reject(tEvent)
          }

          const objectStore = transaction.objectStore(self.dbName)
          // const req = objectStore.openCursor()
          const index = objectStore.index('expireTime')

          // const keyRangeValue = IDBKeyRange.only(conversationId)
          const keyRangeValue = IDBKeyRange.upperBound(Date.now())
          const req = index.openCursor(keyRangeValue)
          req.onsuccess = (event) => {
            const cursor = event.target.result

            // 만료된 데이터 제거.
            if (cursor) {
              cursor.delete()
              cursor.continue()
            } else {
              self.loaded = true

              self.loadWaitingReq.forEach((promise) => {
                promise.resolve(true)
              })
              self.loadWaitingReq = []

              self.isloading = false

              resolve(true)
            }
          }

          req.onerror = (err) => {
            console.log('cursor read error.', err)
            self.loadWaitingReq.forEach((promise) => {
              promise.reject(true)
            })
            self.loadWaitingReq = []

            self.isloading = false

            reject(err)
          }
        } else {
          resolve(true)
        }
      } else {
        self.loadWaitingReq.push({
          resolve,
          reject,
        })
      }
    })
  }

  self.addData = (key, data) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const newItem = {
        [self.key]: key,
        [self.dataKey]: data,
      }

      self.indexList.forEach((item) => {
        newItem[item] = data[item]
      })

      if (self.expireDuration != null) {
        newItem.expireTime = Date.now() + self.expireDuration
      }

      const objectStoreRequest = objectStore.add(newItem)

      objectStoreRequest.onsuccess = () => {
        let item = newItem
        if (options.getSaveData != null) {
          item = options.getSaveData(newItem)
        }

        self.dataMap[key] = item

        resolve(self.dataMap[key])
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to add.', error)
        reject(error)
      }
    })

    return promise
  }

  self.putData = (key, data) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const newItem = {
        [self.key]: key,
        [self.dataKey]: data,
      }

      self.indexList.forEach((item) => {
        newItem[item] = data[item]
      })

      if (self.expireDuration != null) {
        newItem.expireTime = Date.now() + self.expireDuration
      }

      const objectStoreRequest = objectStore.put(newItem)

      objectStoreRequest.onsuccess = () => {
        if (options.beforeRemoveSaveData != null) {
          options.beforeRemoveSaveData(self.dataMap[key])
        }

        let item = newItem
        if (options.getSaveData != null) {
          item = options.getSaveData(newItem)
        }

        self.dataMap[key] = item

        resolve(self.dataMap[key])
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to add.', error)
        reject(error)
      }
    })

    return promise
  }

  self.deleteData = (key) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (self.dataMap[key] != null) {
        if (options.beforeRemoveSaveData != null) {
          options.beforeRemoveSaveData(self.dataMap[key])
        }

        delete self.dataMap[key]
      }

      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const objectStoreRequest = objectStore.delete(key)

      objectStoreRequest.onsuccess = () => {
        resolve(key)
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to delete.', error)
        reject(error)
      }
    })

    return promise
  }

  self.clear = () => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (options.beforeRemoveSaveData != null) {
        Object.values(self.dataMap).forEach((value) => {
          options.beforeRemoveSaveData(value)
        })
      }

      self.dataMap = {}

      const transaction = self.db.transaction([self.dbName], 'readwrite')

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const objectStoreRequest = objectStore.clear()

      objectStoreRequest.onsuccess = () => {
        resolve(true)
      }

      objectStoreRequest.onerror = (error) => {
        console.log('failed to clear.', error)
        reject(error)
      }
    })

    return promise
  }

  // 단일 readwrite 트랜잭션에서 clear() 후 entries 를 모두 put 하는 "원자적 교체".
  // 트랜잭션 커밋(oncomplete)에서만 resolve 하고, 하나라도 실패하면 트랜잭션이 abort 돼
  // 전부 롤백된 뒤 reject 한다. addData 를 다건 반복하면 레코드마다 별도 트랜잭션이라 일부만
  // commit 되는 부분 저장(캐시 잘림)이 가능한데, 이 메서드는 전량 저장 또는 전량 롤백을 보장한다.
  self.bulkReplace = (entries) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    return new Promise((resolve, reject) => {
      let transaction
      try {
        transaction = self.db.transaction([self.dbName], 'readwrite')
      } catch (error) {
        reject(error)
        return
      }

      const nextDataMap = {}

      // request 단위 성공이 아니라 트랜잭션 "커밋"에서만 확정한다.
      transaction.oncomplete = () => {
        self.dataMap = nextDataMap
        resolve(true)
      }
      transaction.onerror = (error) => {
        console.log('bulkReplace transaction error.', error)
        reject(error)
      }
      transaction.onabort = (error) => {
        console.log('bulkReplace transaction aborted.', error)
        reject(error)
      }

      const objectStore = transaction.objectStore(self.dbName)
      objectStore.clear()

      const list = entries || []
      list.forEach(({ key, data }) => {
        const newItem = {
          [self.key]: key,
          [self.dataKey]: data,
        }

        self.indexList.forEach((item) => {
          newItem[item] = data[item]
        })

        if (self.expireDuration != null) {
          newItem.expireTime = Date.now() + self.expireDuration
        }

        objectStore.put(newItem)

        let item = newItem
        if (options.getSaveData != null) {
          item = options.getSaveData(newItem)
        }
        nextDataMap[key] = item
      })
    })
  }

  self.getData = (key) => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      if (self.dataMap[key] != null) {
        resolve(self.dataMap[key])
      } else {
        const transaction = self.db.transaction([self.dbName], 'readonly')

        transaction.onerror = (error) => {
          console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
          reject(error)
        }

        const objectStore = transaction.objectStore(self.dbName)

        const objectStoreRequest = objectStore.get(key)

        objectStoreRequest.onsuccess = () => {
          const { result } = objectStoreRequest

          if (result != null) {
            let item = { ...result }
            if (options.getSaveData != null) {
              item = options.getSaveData(item)
            }

            self.dataMap[key] = item

            resolve(self.dataMap[key])
          } else {
            reject(new Error('No matching data.'))
          }
        }

        objectStoreRequest.onerror = (error) => {
          console.log('failed to get.', error)
          reject(error)
        }
      }
    })

    return promise
  }

  self.getAllData = () => {
    if (self.isActive !== true) {
      return Promise.resolve(null)
    }

    const promise = new Promise((resolve, reject) => {
      const transaction = self.db.transaction([self.dbName], 'readonly')

      transaction.onerror = (error) => {
        console.log('Transaction not opened due to error. Duplicate items not allowed.', error)
        reject(error)
      }

      const objectStore = transaction.objectStore(self.dbName)

      const cursorRequest = objectStore.openCursor()

      const dataList = []
      cursorRequest.onsuccess = (event) => {
        const cursor = event.target.result
        if (cursor) {
          let item = { ...cursor.value }
          if (options.getSaveData != null) {
            item = options.getSaveData(item, cursor.key)
          }

          self.dataMap[cursor.key] = item
          if (options.checkForList == null || options.checkForList(item, cursor.key) === true) {
            dataList.push(item)
          }

          cursor.continue()
        } else {
          resolve({
            dataMap: self.dataMap,
            dataList,
          })
        }
      }

      cursorRequest.onerror = (error) => {
        console.log('failed to getAll.', error)
        reject(error)
      }
    })

    return promise
  }

  self.isLoaded = () => {
    return self.loaded
  }

  if (self.autoInit === true) {
    init()
  }

  self.getDB = async () => {
    if (this.isActive === true) {
      return Promise.resolve(true)
    }
    const initRes = await init()
    return initRes
  }
}

export default BaseDB
